import { useStore } from "@tanstack/react-store";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2, XCircle, Info, X } from "lucide-react";
import { appStore, removeNotification } from "@/store";
import { JSX } from "react/jsx-runtime";

export function Notifications(): JSX.Element {
  const notifications = useStore(appStore, (s) => s.notifications);

  return (
    <div className="fixed bottom-6 right-6 z-[100] flex flex-col gap-2 max-w-sm w-full">
      <AnimatePresence>
        {notifications.map((notification) => (
          <motion.div
            key={notification.id}
            initial={{ opacity: 0, x: 60, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: 60, scale: 0.9 }}
            transition={{ type: "spring", stiffness: 300, damping: 25 }}
            className={`flex items-start gap-3 p-4 rounded-xl shadow-xl border backdrop-blur-sm ${
              notification.type === "success"
                ? "bg-white border-green-100"
                : notification.type === "error"
                  ? "bg-white border-red-100"
                  : "bg-white border-blue-100"
            }`}
          >
            <div className="flex-shrink-0 mt-0.5">
              {notification.type === "success" && (
                <CheckCircle2 size={18} className="text-green-500" />
              )}
              {notification.type === "error" && (
                <XCircle size={18} className="text-red-500" />
              )}
              {notification.type === "info" && (
                <Info size={18} className="text-blue-500" />
              )}
            </div>
            <p className="text-sm text-[#1A1A1A] flex-1 leading-relaxed">
              {notification.message}
            </p>
            <button
              onClick={() => removeNotification(notification.id)}
              className="flex-shrink-0 text-neutral-800 hover:text-[#1A1A1A] transition-colors"
            >
              <X size={14} />
            </button>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
